import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Agenzia } from 'src/app/models/agenzia';
import { AgenziaService } from 'src/app/services/agenzia.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { AgenzieFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'agenzie',
  templateUrl: './agenzie.component.html',
  styleUrls: ['./agenzie.component.scss']
})
export class AgenzieComponent implements OnInit {

  headingText: string = 'Agenzie';


  relations: string[] = ['comune', 'comune.provincia'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',
        type: 'link',
        href: (model) => model.id,

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Codice',
        internalName: 'codice',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Indirizzo',
        internalName: 'fullAddress',
        sortDisabled: true,

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Telefono',
        internalName: 'tel',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Cellulare',
        internalName: 'cell',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Fax',
        internalName: 'fax',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Email',
        internalName: 'email',

      }
    ),

  ];
  constructor(public agenziaService: AgenziaService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<AgenzieComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona una agenzia';
    }

    if (this.data?.defaultSearch) {
      this.search = this.data.defaultSearch;
    }
  }

  async ngOnInit() {

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (agenzia: Agenzia) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare la agenzia ${agenzia.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.agenziaService.delete(agenzia);
          this.toast.success('Agenzia eliminata.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione Agenzia fallita.", "Errore!");
    }
  }



  editFunction = async (agenzia: Agenzia) => {
    try {
      let dialogRef = this.dialog.open(AgenzieFormComponent, { data: agenzia });
      dialogRef.afterClosed().subscribe(async (data: Agenzia) => {
        this.updateDataSource();
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica agenzia fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(AgenzieFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(agenzia?: Agenzia) {
    this.updateDataSource();
  }



}
